var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsShapesRoundedRec3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 53,
    viewBox: "0 0 100 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E3E7FA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.927.664 72.169 10.796V52.5H100V2.809c-.002-.017 0-.033 0-.05C100 1.511 99.001.5 97.77.5c-.298 0-.582.06-.841.167l-.002-.003zM60.927 11.664 36.169 21.796V52.5H64V13.809c-.002-.017 0-.033 0-.05 0-1.248-.999-2.259-2.23-2.259-.298 0-.582.06-.841.167l-.002-.003zM24.927 23.664.169 33.796V52.5H28V25.809c-.002-.017 0-.033 0-.05 0-1.248-.999-2.259-2.23-2.259-.298 0-.582.06-.841.167l-.002-.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsShapesRoundedRec3);
export default __webpack_public_path__ + "static/media/atoms-shapes-rounded-rec-3.02369726d069498d2d3f76d8dde894a4.svg";
export { ForwardRef as ReactComponent };